module.exports = __webpack_public_path__ + "media/violence2.2e413a0a.mp4";